export const VelocityGroupOptions = [
  { value: 'Very High', label: 'Very High' },
  { value: 'High', label: 'High' },
  { value: 'Average', label: 'Average' },
  { value: 'Low', label: 'Low' },
]

export type VelocityGroup = (typeof VelocityGroupOptions)[number]['value']
